import React, { PropsWithChildren, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { ExternalLink } from "@/components/ExternalLink";
import { Image } from 'expo-image';

const styles = StyleSheet.create({
  buttonWrapper: {
    marginTop: 20,
    flexDirection: 'row',
    gap: 20,
    flexWrap: 'wrap',
  },
  playStoreImage: {
    width: 174,
    height: 52,
  },
  appStoreImage: {
    width: 200,
    height: 59,
  },
  appStoreImage2: {
    width: 174,
    height: 59,
  },
});

interface Props {
};

export function WebAppStoreButtons({ }: Props) : React.ReactNode {
  if (AppUtilities.isWebAndroid()) {
    return (
      <View style={styles.buttonWrapper}>
        <ExternalLink href={AppConsts.ANDROID_STORE_LINK} target='_blank' asChild={AppUtilities.isWeb()}>
          <Image source={require('@/assets/images/playstore174x52.png')} style={styles.playStoreImage} />
        </ExternalLink>
      </View>
    );
  } else if (AppUtilities.isWebiOS()) {
    return (
      <View style={styles.buttonWrapper}>
        <Link href="/joinapple" asChild={AppUtilities.isWeb()}>
          <Image source={require('@/assets/images/testflight174x59.png')} style={styles.appStoreImage2} />
        </Link>
      </View>
    );
  } else {
    return null;
  }
};
